import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="P" transform="translate(38.000000, 30.000000)" >
        <path
          d="M0.12 45V0.199997H14.904C17.912 0.199997 20.5573 0.679998 22.84 1.64C25.1227 2.6 26.8933 4.14666 28.152 6.28C29.432 8.41333 30.072 11.2293 30.072 14.728C30.072 18.1627 29.432 20.9573 28.152 23.112C26.8933 25.2453 25.1227 26.8133 22.84 27.816C20.5573 28.8187 17.912 29.32 14.904 29.32H6.52V45H0.12ZM6.52 23.88H14.008C17.272 23.88 19.7147 23.144 21.336 21.672C22.9787 20.1787 23.8 17.8853 23.8 14.792C23.8 11.6773 23.0213 9.37333 21.464 7.88C19.928 6.38667 17.4427 5.64 14.008 5.64H6.52V23.88Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
